import homeRounded from '@iconify-icons/material-symbols/home-rounded';
import historyRounded from '@iconify-icons/material-symbols/history-rounded';
import dashboardRounded from '@iconify-icons/material-symbols/dashboard-rounded';
import sendRounded from '@iconify-icons/material-symbols/send-rounded';

import swapHorizontalBold from '@iconify-icons/mdi/swap-horizontal-bold';
import bankTransfer from '@iconify-icons/mdi/bank-transfer';
import bank from '@iconify-icons/mdi/bank';
import accountGroup from '@iconify-icons/mdi/account-group';
import accountMultiplePlus from '@iconify-icons/mdi/account-multiple-plus';
import cogOutline from '@iconify-icons/mdi/cog-outline';
import { paths } from 'src/routes/paths';

export const mobileNavItems = [
  { title: 'Swap', icon: homeRounded, path: paths.root },
  { title: 'Send USD', icon: sendRounded, path: paths.sendUsd },
  { title: 'To Exchange', icon: bankTransfer, path: paths.toExchange },
  { title: 'Transactions', icon: historyRounded, path: paths.transactions },
];

export const adminMobileNavItems = [
  { title: 'Dashboard', icon: dashboardRounded, path: paths.admin.root },
  { title: 'Transactions', icon: swapHorizontalBold, path: paths.admin.transactions },
  {
    title: 'On-chain',
    icon: swapHorizontalBold,
    path: paths.admin.onchainTransactions,
  },
  { title: 'Fiat', icon: bank, path: paths.admin.fiatBalance },
  { title: 'Admins', icon: accountGroup, path: paths.admin.create },
  { title: 'Users', icon: accountGroup, path: paths.admin.users },
  { title: 'LP Users', icon: accountMultiplePlus, path: paths.admin.lpUsers },
  { title: 'Settings', icon: cogOutline, path: paths.admin.settings },
];
